mutation ApprovalUploadDocument( 
  $document: DocumentUploadInput!
  $approvalId: UUID!) {
  approvalUploadDocument(document: $document,approvalId:$approvalId) {
    uploadLink
    document {
      id
      _documentFileId
      _isAccountingDocument
    }
  }
}
